import * as XLSX from "xlsx";

export function exportToExcel(rows, filename = "export.xlsx", sheetName = "Sheet1") {
  const safeRows = Array.isArray(rows) ? rows : [];
  const worksheet = XLSX.utils.json_to_sheet(safeRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, filename);
}
